import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './ManagementReviewCard.module.scss';

import { IReview } from '../../../../entities/review/model/review';
import { Separator } from '../../Separator';
import { H3, P2, P3 } from '../../Typography';

interface IManagementReviewCard extends IReview {
  className?: string;
}
export const ManagementReviewCard = ({
  name,
  text,
  subtitle,
  className,
}: IManagementReviewCard) => {
  const { t } = useTranslation('index', {
    keyPrefix: 'managementPage.reviews',
  });
  return (
    <div className={clsx(styles.card, className)}>
      <H3>{t(name)}</H3>
      <Separator className={styles.card__separator} />
      {subtitle && <P2 className={styles.card__subtitle}>{t(subtitle)}</P2>}
      <P3 className={styles.card__text}>{t(text)}</P3>
    </div>
  );
};
